import * as React from 'react';
import * as moment from 'moment';

import { connect, Dispatch } from 'react-redux';
import { ICalendarAppState } from '../redux-state';
import { applyPromoCode } from '../redux-state/actions/calendar-api.actions';

import MonthSelectionDropdownView from 'month-selection-dropdown.view';
import { ICalendarAppText } from '../custom/classes/calendar-text';

import { updatePromoCodeString } from '../redux-state/actions/promo-code.actions';
import { waitForImage, imageHasLoaded } from '../redux-state/actions/lazy-load.actions';
import LoaderView from 'loader.view';

interface IExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    isLoading: boolean;
}

interface DispatchToProps {
}

export type LoaderProps = IExternalProps & StateToProps;

export const LoaderBase: React.StatelessComponent<LoaderProps> = props => {
    return (
        <LoaderView {...props} />
    )
}

function mapStateToProps(state: ICalendarAppState, ownProps: IExternalProps): StateToProps {
    return {
        text: state.calendarText,
        isLoading: state.calendar.updating
    }
}

export default connect(mapStateToProps)(LoaderBase);